import { BaseTextMergeElement } from "../BaseTextMergeElement";
import { TextMergeType } from "../../TextMergeType";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { LineBreakElement } from "./LineBreakElement";
import { StateManager } from "../../../Common/StateManager";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";

export class TextElement extends BaseTextMergeElement {
    readonly __type = "text";
    readonly name = "Text";
    readonly styleElement: boolean = false;
    readonly ordinal: number = 1;

    constructor(text?: string) {
        super();
        this._text = text;
    }

    private _text?: string;

    get text(): string | undefined {
        return this._text;
    }

    set text(value: string | undefined) {
        this._text = value;

        StateManager.propertyChanged(this, "text");
    }

    getStorageData(): object {
        let d = super.getStorageData();

        Reflect.set(d, "text", this._text);
        return d;
    }

    setStorageData(data: object) {
        super.setStorageData(data);
        this._text = Reflect.get(data, "text");
    }

    output(_data: ExecutionData, config: TextMergeConfiguration, _textContext: ITestingContext | undefined): string {
        if (config.type === TextMergeType.PlAIN) {
            // strip out any line breaks

            let output = (this._text ?? "").replace(/(\r\n|\n|\r)/gm, "");
            return output;
        } else {
            return this._text ?? "";
        }
    }

    canAdd(config: TextMergeConfiguration): boolean {
        return (
            config.type === TextMergeType.HTML ||
            config.type === TextMergeType.PlAIN ||
            config.type === TextMergeType.MULTI_LINE
        );
    }

    override onDeselect() {
        super.onDeselect();

        if (this.text) {
            let pieces = this.text.split(/\r?\n/);

            let index = this.parent?.elements.indexOf(this);

            if (index === undefined) throw new Error("item not found in collection");

            index = index! + 1;

            let topTextSet = false;
            for (let p of pieces) {
                if (!topTextSet) {
                    this.text = p.trim();
                    topTextSet = true;
                } else {
                    // add line break
                    this.parent?.addElement(new LineBreakElement(), index);
                    index = index + 1;
                    // add new text
                    this.parent?.addElement(new TextElement(p.trim()), index);
                    index = index + 1;
                }
            }
        }
    }
}
